module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/AmwayIcons.eot?5v2gxx
// module id = CtTc
// module chunks = 0